module.exports = __webpack_public_path__ + "img/WEIXIN.3ee21d1c.jpg";